import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { translate } from "../../../i18n";

export const CALENDAR_COLORS = {
    MATCH_FULLY_BOOKED: '#023F7F',     // brand.500 — deep blue
    MATCH_PARTIALLY_BOOKED: '#6D9FD3', // brand.300 — lighter blue
    BLOCKADE: '#B8453A',               // danger — warm brick red
    COACHING_SESSION: '#7C3AED',       // violet-600
    EVENT: '#9333EA',                  // purple-600 (distinct from coaching)
    CANCELED: '#B8453A',               // danger — same brick red
    AVAILABLE: '#10B981',              // accent.500 — emerald
    ORDERS: '#C4883A',                 // warning.500 — warm amber
};

export default function CalendarLegend() {
    const bg = useColorModeValue('gray.50', 'whiteAlpha.50');
    const borderColor = useColorModeValue('secondaryGray.100', 'whiteAlpha.100');

    return (
        <Flex
            wrap="wrap"
            gap={2}
            mb={4}
            px={3}
            py={2}
            bg={bg}
            border="1px solid"
            borderColor={borderColor}
            borderRadius="md"
        >
            <Legend title={translate('calendar.available')} color={CALENDAR_COLORS.AVAILABLE} variant="bg" />
            <Legend title={translate('calendar.games_partially_booked')} color={CALENDAR_COLORS.MATCH_PARTIALLY_BOOKED} />
            <Legend title={translate('calendar.games_fully_booked')} color={CALENDAR_COLORS.MATCH_FULLY_BOOKED} />
            <Legend title={translate('calendar.coaching_sessions')} color={CALENDAR_COLORS.COACHING_SESSION} />
            <Legend title={translate('calendar.event')} color={CALENDAR_COLORS.EVENT} />
            <Legend title={translate('calendar.canceled')} color={CALENDAR_COLORS.CANCELED} strikethrough />
            <LegendWithBorder title={translate('calendar.has_orders')} color={CALENDAR_COLORS.ORDERS} />
        </Flex>
    );
}

function Legend({ title, color, variant, strikethrough }: { title: string; color: string; variant?: 'bg'; strikethrough?: boolean }) {
    const textColor = useColorModeValue('secondaryGray.700', 'gray.300');

    return (
        <Flex align="center" gap="6px" px={2} py={1}>
            <Box
                w="10px"
                h="10px"
                bg={color}
                borderRadius={variant === 'bg' ? '2px' : 'full'}
                flexShrink={0}
                opacity={variant === 'bg' ? 0.6 : 1}
            />
            <Text
                fontSize="xs"
                color={textColor}
                fontWeight="500"
                textDecoration={strikethrough ? 'line-through' : undefined}
            >
                {title}
            </Text>
        </Flex>
    );
}

function LegendWithBorder({ title, color }: { title: string; color: string }) {
    const textColor = useColorModeValue('secondaryGray.700', 'gray.300');

    return (
        <Flex align="center" gap="6px" px={2} py={1}>
            <Box
                w="10px"
                h="10px"
                bg="transparent"
                borderLeft={`3px solid ${color}`}
                borderRadius="1px"
                flexShrink={0}
            />
            <Text fontSize="xs" color={textColor} fontWeight="500">{title}</Text>
        </Flex>
    );
}
